module.exports = __webpack_public_path__ + "img/9.982ba0cd.jpg";